module.exports = __webpack_public_path__ + "img/ic-gcash.399fdc81.png";